<template>
  <div class='home'>
    <AreaList
      v-show='listView'
      @newArea='onClickNewFromList'
      @editArea='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <AreaForm
      v-show='formView'
      :area='area'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import AreaList from '@/components/area/AreaList.vue'
import AreaForm from '@/components/area/AreaForm.vue'

export default {
  name: 'Area',
  components: {
    AreaList,
    AreaForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      area: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.area = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.area = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.area = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getStateList')
  }
}
</script>
